<template>
  <div>
    <div v-if="employee" class="container py-5 block-content" id="singleUser">
      <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "ito consult GmbH",
          "item": "https://ito-consult.de/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Wir",
          "item": "https://ito-consult.de/wir/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Team",
          "item": "https://ito-consult.de/wir/team"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "{{employee.firstname}} {{employee.lastname}}",
          "item": "https://ito-consult.de/wir/team/{{employee.slug}}"
        }]
      }
      </script>
      <router-link class="close" title="Ansicht schließen" :to="{'name' : 'ito.team'}">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>
        </svg>
      </router-link>
      <div class="d-md-flex" itemscope itemtype="https://schema.org/Person">
        <div class="avatar me-md-5 mb-5 mb-md-0">
            <img itemprop="image" width="478" height="318" class="img-fluid" :src="generateThumbnail(employee.image_avatar.data.asset_url,478,318,60,'contain')" />
            <img width="478" height="318" v-if="employee.image_fullsize" class="img-fluid secret" :src="generateThumbnail(employee.image_fullsize.data.asset_url,478,318,50,'contain')" />
        </div>
        <div class="vcard pb-5">
          <h2 class="m-0 p-0" itemprop="name">{{employee.firstname}} {{employee.lastname}}</h2>
          <h3 class="pt-0 mt-0" itemprop="jobTitle">{{employee.job}}</h3>
          <blockquote class="py-4" v-if="employee.quote">
            <span v-html="employee.quote"></span>
            <span class="author d-block" v-if="employee.quote_author">{{employee.quote_author}}</span>
          </blockquote>
          <article class="mb-4 d-content" v-html="employee.description"></article>
          <p>
            <a v-if="employee.mail" @click.stop="hideSingleView" class="btn btn-outline-ito d-block d-md-inline me-3 mb-3 mb-md-0" :href="'mailto:'+employee.mail">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
            </svg>&nbsp;<span itemprop="email">{{employee.mail}}</span>
            </a>
            <a v-if="employee.phone" @click.stop="hideSingleView" class="btn btn-outline-ito d-block d-md-inline me-3 mb-3 mb-md-0" :href="'tel:'+employee.phone">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
            </svg>&nbsp;<span itemprop="telephone">{{employee.phone}}</span>
            </a>
            <a v-if="employee.chat" @click.stop="hideSingleView" class="btn btn-outline-ito d-block d-md-inline me-3 mb-3 mb-md-0" href="https://teams.microsoft.com/l/chat/0/0?users=eba.ito.im">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 24 24">
              <path fill="currentColor" d="M19.19 8.77Q18.73 8.77 18.33 8.6 17.94 8.43 17.64 8.13 17.34 7.83 17.17 7.44 17 7.04 17 6.58 17 6.13 17.17 5.73 17.34 5.33 17.64 5.04 17.94 4.74 18.33 4.57 18.73 4.39 19.19 4.4 19.64 4.39 20.04 4.57 20.44 4.74 20.74 5.04 21.03 5.33 21.21 5.73 21.38 6.13 21.38 6.58 21.38 7.04 21.21 7.44 21.04 7.83 20.74 8.13 20.44 8.43 20.04 8.6 19.64 8.77 19.19 8.77M19.19 5.65Q18.8 5.65 18.5 5.92 18.25 6.19 18.25 6.58 18.25 6.97 18.5 7.25 18.8 7.5 19.19 7.5 19.58 7.5 19.85 7.25 20.13 7 20.13 6.58 20.13 6.19 19.85 5.92 19.58 5.65 19.19 5.65M22 10.33V15Q22 15.63 21.76 16.2 21.5 16.77 21.09 17.19 20.66 17.62 20.09 17.86 19.5 18.11 18.88 18.11 18.5 18.11 18.12 18 17.73 17.93 17.41 17.75 17.17 18.54 16.7 19.19 16.23 19.84 15.6 20.3 14.97 20.76 14.21 21 13.45 21.27 12.63 21.27 11.67 21.27 10.82 20.94 10 20.61 9.32 20 8.66 19.43 8.23 18.64 7.79 17.84 7.66 16.9H2.83Q2.5 16.9 2.24 16.65 2 16.41 2 16.07V7.73Q2 7.39 2.24 7.14 2.5 6.9 2.83 6.9H10Q9.71 6.3 9.71 5.65 9.71 5.04 9.94 4.5 10.16 4 10.56 3.58 10.96 3.19 11.5 2.96 12 2.73 12.62 2.73 13.23 2.73 13.76 2.96 14.29 3.19 14.69 3.58 15.09 4 15.31 4.5 15.54 5.04 15.54 5.65 15.54 6.25 15.31 6.79 15.09 7.32 14.69 7.71 14.29 8.11 13.76 8.34 13.23 8.57 12.62 8.57 12.47 8.57 12.31 8.55 12.16 8.53 12 8.5V9.4H21.06Q21.45 9.4 21.73 9.67 22 9.94 22 10.33M12.63 4Q12.28 4 12 4.11 11.67 4.24 11.44 4.47 11.22 4.7 11.09 5 10.96 5.31 10.96 5.65 10.96 6 11.09 6.3 11.22 6.6 11.44 6.83 11.67 7.05 12 7.19 12.28 7.32 12.63 7.32 12.97 7.32 13.27 7.19 13.57 7.05 13.8 6.83 14.03 6.6 14.16 6.3 14.3 6 14.3 5.65 14.3 5.31 14.16 5 14.03 4.7 13.8 4.47 13.57 4.24 13.27 4.11 12.97 4 12.63 4M7.78 10.18H9.66V8.62H4.34V10.18H6.22V15.18H7.78M16.38 16.27V10.65H12V16.07Q12 16.41 11.76 16.65 11.5 16.9 11.17 16.9H8.92Q9.05 17.57 9.39 18.15 9.73 18.72 10.21 19.14 10.69 19.55 11.31 19.79 11.92 20 12.63 20 13.4 20 14.08 19.73 14.76 19.43 15.28 18.92 15.79 18.41 16.08 17.73 16.38 17.05 16.38 16.27M20.75 15V10.65H17.63V16.36Q17.88 16.61 18.2 16.74 18.5 16.86 18.88 16.86 19.27 16.86 19.61 16.71 19.95 16.56 20.2 16.31 20.46 16.06 20.6 15.71 20.75 15.37 20.75 15Z" />
            </svg>&nbsp;Chat
            </a>
            <a v-if="employee.vcard" class="btn btn-outline-ito d-block d-md-inline me-3 mb-3 mb-md-0" href="eb.vcf">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-badge-fill" viewBox="0 0 16 16">
              <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"/>
            </svg>&nbsp;V-Card
            </a>
            <span itemprop="url" :content="'https://ito-consult.de/wir/team/'+ employee.slug"></span>
            <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
              <meta itemprop="streetAddress" content="Boltenhagener Straße. 140">
              <meta itemprop="addressLocality" content="Dresden">
              <meta itemprop="addressCountry" content="Germany">
              <meta itemprop="postalCode" content="01109">
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'
import router from '@/router'
export default {
  name: 'SingleEmployee',
  data: function () {
    return {
      employee: null
    }
  },
  computed: {
    employee_slug: function () {
      return this.$route.params.id
    }
  },
  mounted: function () {
    this.$parent.singleViewOn = true
    store.commit('loadingStatus', false)
    store.commit('setScrollPosition', window.scrollY)
    store.commit('noScollBodyStatus', true)
  },
  async beforeMount () {
    await axios.get('/employees?fields=*.*&filter[slug]=' + this.employee_slug)
      .then(response => {
        if (response.data.data.length > 0) {
          this.employee = response.data.data[0]
        } else {
          // Falls slug in directus nicht vorhanden, 404 Umleitung
          router.replace({ name: '404' })
        }
      })

    // Fallback if User not found
    if (typeof this.employee === 'undefined') {
      this.$parent.singleViewOn = false
      this.$router.push({ name: 'ito.team' }).catch(() => {})
    }
  },
  methods: {
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }
  },
  beforeDestroy () {
    // hide single view compontent on unload (history back bug)
    this.$parent.singleViewOn = false
    store.commit('loadingStatus', false)
  }
}
</script>
<style scoped lang="less">
  /* teammembersingle */
  #singleUser .avatar {min-width: 250px; overflow: hidden; position: relative; padding-top: 66.6666% }
  @media(min-width: 992px) {#singleUser .avatar { padding-top: 0%}}
  #singleUser .avatar img {position: absolute; top: 0; left: 50%; transform: translateX(-50%)}
  #singleUser .avatar img {z-index: 1}
  #singleUser .avatar img.secret {z-index: 2; opacity: 0; transition: opacity 500ms;}
  #singleUser .avatar:hover img.secret {opacity: 1;}
  @media(min-width: 1200px) {
    #singleUser .avatar {min-width: 400px;}
  }
  #teammembersingle > #singleUser {max-width: 80%; color: #666}
  .btn { white-space: nowrap; }
  blockquote {
    font-size: 1.2rem;
    .author {
      font-family: var(--bs-font-sans-serif);
      font-style: normal;
      color: #aaa;
      margin: 0; padding: 0;
    }
  }

  #focusHelper {opacity: 0; position: fixed; top: -100vh}
a.close {color: var(--ito-red); position: fixed; top: 2.5rem; right: 2.5rem; z-index: 1000}

</style>
